import { Component, computed, effect, inject, signal } from '@angular/core';
import { OpkraevningService } from '../opkraevning.service';
import { ScrollPanel } from 'primeng/scrollpanel';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '@core/auth/auth.service';
import { RettighedsType } from '@core/auth/rettighed.model';
import { Checkbox } from 'primeng/checkbox';
import { BooleanPipe } from '@core/pipes/boolean.pipe';
import { ButtonModule } from 'primeng/button';
import { Message } from 'primeng/message';
import { OpkraevningsListerService } from '@features/opkraevningslister/opkraevningslister.service';
import { CprNummerPipe } from '@core/pipes/cprnummer.pipe';
import { DatePipe, DecimalPipe } from '@angular/common';
import { Textarea } from 'primeng/textarea';

@Component({
  selector: 'app-opkraevning-detail',
  imports: [
    BooleanPipe,
    CprNummerPipe,
    DecimalPipe,
    DatePipe,
    ButtonModule,
    ScrollPanel,
    ReactiveFormsModule,
    Checkbox,
    Message,
    Textarea,
  ],
  templateUrl: './opkraevning-detail.component.html',
  styleUrl: './opkraevning-detail.component.css',
})
export class OpkraevningDetailComponent {
  authService = inject(AuthService);
  opkraevningService = inject(OpkraevningService);
  opkraevningsListeService = inject(OpkraevningsListerService);
  form: FormGroup;
  infoMessage = signal('');

  opkraevningsListe = computed(() =>
    this.opkraevningsListeService.selectedOpkraevningsListe()
  );

  opkraevning = computed(() => this.opkraevningService.selectedOpkraevning());

  allowEdit = computed(
    () =>
      this.authService.hasRettighed(
        RettighedsType.AdminOpkraevningslisterSkriv
      ) &&
      !this.opkraevningsListe()?.afsendt &&
      (this.opkraevning()?.indlaesningStatus == 'OK' ||
        this.opkraevning()?.indlaesningStatus == 'BEMAERKNING') &&
      this.opkraevning()?.indbetalingsReference
  );

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      godkendt: [],
      piKommentar: [],
    });

    effect(() => {
      const opkraevning = this.opkraevningService.selectedOpkraevning();
      if (!opkraevning) {
        this.form.reset();
      } else {
        this.infoMessage.set('');
        this.form.setValue({
          godkendt: opkraevning.godkendt || false,
          piKommentar: opkraevning.piKommentar || '',
        });
      }
    });
  }

  async onClickSave() {
    const o = this.opkraevning();
    if (o) {
      const newData = {
        ...o,
        ...this.form.value,
      };
      await this.opkraevningService.datasource.update(o.id, newData);
    }
    this.opkraevningsListeService.activeTab.set('detail');
    await this.opkraevningsListeService.loadSummary();
  }

  onClickCancel() {
    this.opkraevningsListeService.activeTab.set('detail');
  }
}
